/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateTemplateLimit from 'components/TemplateLimit/create.templateLimit';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const TemplateLimitCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลเทมเพลตเลขอั้น' : 'สร้างข้อมูลเทมเพลตเลขอั้น' }</title>
         </Helmet>
         <HasAccess
            roles={['Owner']}
            permissions={['period-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลเทมเพลตเลขอั้น' : 'สร้างข้อมูลเทมเพลตเลขอั้น' }`}>
               <CreateTemplateLimit id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default TemplateLimitCreatePage;
